import { render, staticRenderFns } from "./PermissionsAndDeclarations.vue?vue&type=template&id=88b18f12&scoped=true&"
import script from "./PermissionsAndDeclarations.vue?vue&type=script&lang=js&"
export * from "./PermissionsAndDeclarations.vue?vue&type=script&lang=js&"
import style0 from "./PermissionsAndDeclarations.vue?vue&type=style&index=0&id=88b18f12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88b18f12",
  null
  
)

export default component.exports